export function WhyWeSpecialize() {
  const reasons = [
    {
      icon: 'ri-funds-line',
      title: 'Deep Market Knowledge',
      description: 'We understand the unique characteristics and valuation methods for small multifamily properties. Our team has extensive experience evaluating duplexes, triplexes, quadplexes, and five-unit buildings across diverse markets and neighborhoods.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Fast Closing Process',
      description: 'Small apartment buildings often require quick decisions. We can close in as little as 7-14 days, helping you avoid prolonged carrying costs, property taxes, insurance premiums, and maintenance expenses that accumulate while waiting for traditional buyers.'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Cash Offers',
      description: 'We make all-cash offers that eliminate financing contingencies and appraisal issues. This means no deals falling through at the last minute due to buyer financing problems, giving you certainty and peace of mind throughout the transaction.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Buy As-Is Condition',
      description: 'Whether your property is fully occupied, partially vacant, or completely empty, we buy it in its current condition. No need to make repairs, renovations, or improvements. We handle everything after closing, saving you time and money.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Simplified Process',
      description: 'We handle all the complex paperwork, tenant notifications, lease assignments, and legal requirements. Our streamlined process eliminates the stress and confusion often associated with selling multifamily properties.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Proven Track Record',
      description: 'We have successfully purchased hundreds of small apartment buildings from owners in various situations. Our reputation for fair dealing, transparent communication, and reliable closings speaks for itself in the industry.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Why We Specialize in Small Apartment Buildings
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our expertise in small multifamily properties means you get a fair offer, fast closing, and hassle-free transaction every time.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 rounded-xl shadow-lg">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                We Buy Old and Vacant Small Apartment Buildings
              </h3>
              <p className="text-lg text-gray-600 mb-4">
                Many property owners struggle to sell older or vacant small apartment buildings through traditional channels. Real estate agents may be reluctant to list properties that need significant work, and conventional buyers often get cold feet when they see deferred maintenance or vacancy issues.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                We specialize in purchasing these challenging properties. Whether your duplex has been sitting vacant for months, your triplex needs a new roof, or your quadplex has outdated plumbing and electrical systems, we're interested. We see the potential in properties that others overlook.
              </p>
              <p className="text-lg text-gray-600">
                Vacant properties are actually ideal for us because they allow for immediate renovation work without tenant coordination. Old buildings with character and solid bones are valuable investments when properly renovated and managed.
              </p>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/06c0792c04d59bd868e7eb95604aa834.jpg"
                alt="Old Vacant Small Apartment Building"
                className="w-full h-full object-cover rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}